/** 图像 Worker 的消息协议（主线程 ↔ Worker 共享）与纯计算函数。 */

export interface PrepareRequest {
  kind: 'prepare';
  id: number;
  bitmap: ImageBitmap;
  maxDim: number;
}

export interface PrepareResponseReady {
  kind: 'ready';
  id: number;
  canvas: OffscreenCanvas;
  width: number;
  height: number;
}

export interface PrepareResponseError {
  kind: 'error';
  id: number;
  message: string;
}

export type WorkerResponse = PrepareResponseReady | PrepareResponseError;

/**
 * 等比缩放尺寸：最长边不超过 maxDim，且不放大（scale ≤ 1）。
 * 纯函数，便于在不依赖 DOM/Worker 的环境下单元测试。
 */
export function computeScaledSize(
  naturalW: number,
  naturalH: number,
  maxDim: number,
): { width: number; height: number; scale: number } {
  if (!(naturalW > 0) || !(naturalH > 0)) {
    throw new Error(`图片尺寸无效：w=${naturalW} h=${naturalH}`);
  }
  if (!(maxDim > 0)) throw new Error(`maxDim 必须为正，收到 ${maxDim}`);

  const scale = Math.min(1, maxDim / Math.max(naturalW, naturalH));
  const width = Math.max(1, Math.round(naturalW * scale));
  const height = Math.max(1, Math.round(naturalH * scale));
  return { width, height, scale };
}
